import { ReactNode } from "react"
import Header from "./Header"
import Footer from "./Footer"
import HorizontalSeparator from "./HorizontalSeparator";

export default function Layout({ children }: { children: ReactNode }) {
    return <div className="flex flex-col min-h-screen bg-black text-white">
        <Header />
        <main className="flex-1 pt-24 sm:pt-44">
            {children}
        </main>
        <div className="pb-2 pt-4">
            <HorizontalSeparator />
            <Footer />
        </div>
    </div>
}